// Validación de teléfono (igual que el backend en contactsController.js)
// Acepta 10 dígitos, con o sin espacios, guiones, paréntesis o +52 al inicio.
export const normalizarTelefono = (valor) => {
  let d = (valor ?? "").toString().replace(/\D/g, "");
  if (d.length === 13 && d.startsWith("521")) d = d.slice(3);
  else if (d.length === 12 && d.startsWith("52")) d = d.slice(2);
  return d.length === 10 ? d : null;
};

export const telefonoValido = (valor) => normalizarTelefono(valor) !== null;

export const emailValido = (valor) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((valor ?? "").trim());
